'use client'

import type { Address } from '@morpho-org/blue-sdk'

import { Icon } from '@repo/ui'
import { Timelock } from '@repo/ui/icons'
import { memo } from 'react'

import {
  PendingActionsList,
  VaultPendingTimelockInfo
} from '@/components/VaultPage/components/VaultPendingTimelockInfo'

import type { VaultV2PendingTimelock as VaultV2PendingTimelockType } from '../types/pendingTimelocks'

import { VaultV2PendingTimelock } from '../VaultV2PendingTimelock'

interface VaultV2PendingTimelocksIndicatorProps {
  pendingTimelocks: VaultV2PendingTimelockType[]
  currentManagementFee?: number | null
  currentPerformanceFee?: number | null
  currentManagementFeeRecipient?: Address | null
  currentPerformanceFeeRecipient?: Address | null
}

const VaultV2PendingTimelocksIndicator = ({
  pendingTimelocks,
  currentManagementFee,
  currentPerformanceFee,
  currentManagementFeeRecipient,
  currentPerformanceFeeRecipient
}: VaultV2PendingTimelocksIndicatorProps) => {
  const pendingActionsContent = (
    <PendingActionsList count={pendingTimelocks.length}>
      {pendingTimelocks.map((pendingTimelock, index) => (
        <VaultV2PendingTimelock
          key={`${pendingTimelock.functionName}-${index}`}
          validAt={pendingTimelock.validAt}
          functionName={pendingTimelock.functionName}
          decodedData={pendingTimelock.decodedData}
          disableNavigation
          currentManagementFee={currentManagementFee}
          currentPerformanceFee={currentPerformanceFee}
          currentManagementFeeRecipient={currentManagementFeeRecipient}
          currentPerformanceFeeRecipient={currentPerformanceFeeRecipient}
        />
      ))}
    </PendingActionsList>
  )

  return (
    <VaultPendingTimelockInfo content={pendingActionsContent}>
      <Icon className="text-info-foreground hover:text-info-foreground" icon={<Timelock />} />
    </VaultPendingTimelockInfo>
  )
}

export default memo(VaultV2PendingTimelocksIndicator)
